export default __webpack_public_path__ + "static/media/sucess-codeg.5212bc0e.png";